var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"moveToFolderModalRef",attrs:{"size":"md","hide-footer":"","title":_vm.npContent('choose a folder')}},[_c('folder-tree',{attrs:{"moduleId":_vm.moduleId,"active-folder-key":_vm.folderSelectionKey,"usage":"move"},on:{"folderSelected":_vm.onFolderSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }